import './styles.scss';

import PropTypes from 'prop-types';
import React from 'react';
import { ButtonGroup, Dropdown } from 'react-bootstrap';

export class DropdownSelect extends React.Component {
  state = {
    activeValue: undefined,
  };

  componentDidMount() {
    const { setActiveValue } = this.props;

    if (setActiveValue) {
      this.setActiveValueState(setActiveValue);
    }
  }

  componentDidUpdate(prevProps, _prevState, _snapshot) {
    const { setActiveValue } = this.props;

    if (prevProps.setActiveValue !== setActiveValue) {
      this.setActiveValueState(setActiveValue);
    }

    const { values } = this.props;
    const { activeValue } = this.state;

    if (activeValue && !values.includes(activeValue)) {
      this.setActiveValueState(undefined);
    }
  }

  handleDropDownClick(value) {
    this.setActiveValueState(value);
  }

  setActiveValueState(newValue) {
    this.setState({ activeValue: newValue });
    const { onSelect } = this.props;

    onSelect(newValue);
  }

  render() {
    const {
      values, disabled, defaultText,
    } = this.props;
    const { activeValue } = this.state;
    let dropdownButton;

    if (!disabled) {
      dropdownButton = (
        <Dropdown.Toggle variant="light" split id="dropdown-split-basic" className="DropdownSelect">
          { activeValue || defaultText }
        </Dropdown.Toggle>
      );
    } else {
      dropdownButton = (
        <Dropdown.Toggle variant="light" split id="dropdown-split-basic" className="DropdownSelect" disabled>
          { (values && values.length) ? values : defaultText }
        </Dropdown.Toggle>
      );
    }

    return (
      <Dropdown as={ButtonGroup} className="Dropdown w-100">
        { dropdownButton }
        <Dropdown.Menu>
          { values.map((value) => (
            <Dropdown.Item
              key={value}
              onClick={() => this.handleDropDownClick(value)}
              active={activeValue === value}
            >
              { value }
            </Dropdown.Item>
          )) }
        </Dropdown.Menu>
      </Dropdown>
    );
  }
}

DropdownSelect.defaultProps = {
  defaultText: 'Choose...',
  values: [],
  disabled: false,
  onSelect: () => null,
  setActiveValue: undefined,
};

DropdownSelect.propTypes = {
  defaultText: PropTypes.string,
  values: PropTypes.arrayOf(PropTypes.string),
  disabled: PropTypes.bool,
  onSelect: PropTypes.func,
  setActiveValue: PropTypes.string,
};

export default DropdownSelect;
